<template>

    <footer>
      <div id="titanNavigationFooter" class="flex_display">
        <div class="footer_text flex_display_centered_child">NeonCRM Copyright &copy; 2018 Z2 Systems, Inc. All rights reserved.</div>
      </div>
    </footer>

</template>

<script>
  export default {
    name: 'neon-footer',
    data () {
      return {}
    },
    components: {},
    methods: {}
  }
</script>

<style>

  footer {
    bottom: 0;
    width: 100%;
    height: 68px;
    border-top: 1px solid #e5e5e5;
  }


  #titanNavigationFooter {
    height: 100%;
  }



</style>



// WEBPACK FOOTER //
// src/modules/common/Footer.vue